<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("whMonitoringDocumentPhotoAdd") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >
                    <div class="row"></div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Type</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="['SO', 'PO']"
                          return-object
                          v-model="forms.type"
                        ></v-select>

                        <div v-if="errors.type">
                          <div
                            v-for="error in errors.type"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Reference No</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="reference_no"
                          :placeholder="'Reference No'"
                          v-model="forms.reference_no"
                          required
                        />
                        <div v-if="errors.reference_no">
                          <div
                            v-for="error in errors.reference_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("fulfillment_name") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchWarehouse"
                          return-object
                          required
                          label="warehouse_id"
                          v-model="forms.warehouse_id"
                          @search="asyncSearchWarehouse"
                          @input="changedWarehouse"
                          :reduce="(option) => option.warehouse_id"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.warehouse_id }} - {{ option.name }}
                          </template>
                        </v-select>
                        <div v-if="errors.warehouse_id">
                          <div
                            v-for="error in errors.warehouse_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("company_name") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <v-select
                          :options="fetchCompany"
                          return-object
                          label="customer_id"
                          v-model="forms.customer_id"
                          @search="asyncSearchCompany"
                          :disabled="forms.warehouse_id == null"
                          :reduce="(option) => option.customer_id"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.customer_id }} - {{ option.customer_name }}
                          </template>
                        </v-select>
                        <div v-if="errors.customer_id">
                          <div
                            v-for="error in errors.customer_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("driver_name") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="driver_name"
                          :placeholder="$t('driver_name')"
                          v-model="forms.driver_name"
                          required
                        />
                        <div v-if="errors.driver_name">
                          <div
                            v-for="error in errors.driver_name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("vehicle_no") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="vehicle_no"
                          :placeholder="$t('vehicle_no')"
                          v-model="forms.vehicle_no"
                          required
                        />
                        <div v-if="errors.vehicle_no">
                          <div
                            v-for="error in errors.vehicle_no"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >Images</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <vue-dropzone
                          ref="myVueDropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          @vdropzone-file-added="addFile"
                          @vdropzone-removed-file="removeFile"
                          @vdropzone-duplicate-file="removeFile"
                          :duplicateCheck="true"
                          @vdropzone-thumbnail="thumbnailGenerated"
                        ></vue-dropzone>

                        <div v-if="errors.details">
                          <div
                            v-for="error in errors.details"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="btn btn-warning text-black fw-bolder btn-icon-text"
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <vue-easy-lightbox
          escDisabled
          moveDisabled
          :visible="visible"
          :imgs="imgs"
          :index="imageIndex"
          @hide="handleHide"
        ></vue-easy-lightbox>

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import VueEasyLightbox from "vue-easy-lightbox";
import imageCompression from "browser-image-compression";

export default {
  name: "DocumentPhotoAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    vueDropzone: vue2Dropzone,
    VueEasyLightbox,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      fetchUserType: [],
      user_type: [],
      fetchRole: [],
      fetchCompany: [],
      fetchCompanyNotLinc: [],
      permision_role: [],
      company: [],
      role: [],
      forms: { name: "", usernmae: "" },
      images: [],
      fetchWarehouse: [],
      dropzoneOptions: {
        url: "http://localhost",
        thumbnailWidth: 300,
        autoProcessQueue: false,
        createImageThumbnails: true,
        // maxFilesize: 2, // MB
        addRemoveLinks: true,
        previewTemplate: this.template(),
        // headers: { "My-Awesome-Header": "header value" }
      },
      imgs: [],
      visible: false,
      imageIndex: 0,
    };
  },
  computed: {},
  watch: {},
  methods: {
    changedWarehouse(ev) {
      this.fetchCompany = [];
      if(ev){
        this.detailWarehouse(ev);
      }
    },
    handleHide() {
      this.visible = false;
    },
    template: function () {
      return `<div class="dz-preview dz-file-preview">
          <div class="dz-image">
            <img data-dz-thumbnail />
          </div>
          <div class="dz-details">
            <div class="dz-filename"><span data-dz-name></span></div>
            <div class="dz-size" data-dz-size></div>
          </div>
          <div class="dz-success-mark"><span>✔</span></div>
          <div class="dz-error-mark"><span>✘</span></div>
          <div class="dz-error-message"><span data-dz-errormessage></span></div>
          <div class="dz-remove" data-dz-remove>Remove file</div>
          <button class="btn btn-primary my-custom-button" type="button" data-dz-custom-button><i class="mdi mdi-eye"></i></button>
        </div>
        `;
    },
    thumbnailGenerated(file) {
      // Access the custom button for this specific file
      const customButton =
        file.previewElement.querySelectorAll(".my-custom-button");
      let imgLength = this.imgs.length - 1;
      for (var i = 0; i < customButton.length; i++) {
        customButton[i].addEventListener("click", () => {
          this.handleCustomButtonClick(file, imgLength);
        });
      }
    },
    handleCustomButtonClick(file, index) {
      this.imageIndex = index;
      this.visible = true;
    },

    loadWarehouse() {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/index?status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

     detailWarehouse(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/detail/"+ev;

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.customer_access;
          // console.log(response);
          // this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    asyncSearchWarehouse(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/warehouse/index?status=active&warehouse_id=" +
        ev;
      this.fetchUser = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchWarehouse = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    loadCompany() {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/customer/index?status=active";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    asyncSearchCompany(ev) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/customer/index?status=active&warehouse_id=" +
        ev;
      this.fetchUser = [];
      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          this.fetchCompany = response.data.datas.data;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
    removeFile() {
      this.images = this.$refs.myVueDropzone.getAcceptedFiles();
      this.imgs = this.$refs.myVueDropzone.getAcceptedFiles().map((file) => {
        return URL.createObjectURL(file);
      });
    },
    async addFile(file) {
      const options = {
        maxSizeMB: 0.7, // max file size in MB
        useWebWorker: true, // use web worker for performance
      };

      // Check Uploaded File Is Greater Than 1.5 MB
      let fileMb = file.size / 1024 / 1024;
      if (fileMb > 1) {
        this.isLoading = true;

        try {
          const compressedFile = await imageCompression(file, options);

          let finalFile = new File([compressedFile], file.name, {
            type: compressedFile.type,
          });

          this.images.push(finalFile);
          this.imgs.push(URL.createObjectURL(finalFile));
          this.loading();
        } catch (error) {
          console.error("Image compression failed:", error);
          this.loading();
        }
      } else {
        this.images.push(file);
        this.imgs.push(URL.createObjectURL(file));
      }
    },
    resetForm() {
      this.forms.name = "";
      this.forms.username = "";
      this.forms.password = "";
      this.forms.email = "";
      this.forms.companyId = "";
      this.forms.roleId = "";
      this.company = [];
      this.role = [];
    },

    backForm() {
      window.location.href = "/wh-monitoring/document-photo";
    },

    submitData() {
      this.fade(true);
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/document-header/create";
      let formData = new FormData();
      formData.append("type", this.forms?.type ? this.forms?.type : "");
      formData.append("reference_no", this.forms.reference_no);
      formData.append(
        "warehouse_id",
        this.forms?.warehouse_id ? this.forms?.warehouse_id : "",
      );
      formData.append(
        "customer_id",
        this.forms?.customer_id ? this.forms.customer_id : "",
      );
      formData.append("driver_name", this.forms.driver_name);
      formData.append("vehicle_no", this.forms.vehicle_no);
      this.images.forEach((file) => {
        formData.append("details[]", file);
      });

      console.log(formData);
      this.$http
        .post(baseURI, formData)
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.errors = [];
            var params = this.$onRandom(response.data.datas.document_header_id);
            window.location.href =
              "/wh-monitoring/document-photo/detail/" +
              params +
              "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
          this.loading();
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
          this.loading();
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      this.companyCode = this.detailUser.company_detail.code;
      // this.permision_role = userDatas.sub.permision_role;
      this.companyCode = this.detailUser.company_detail.code;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller ==
            "WhMonitoringDocumentHeaderController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadWarehouse();
    // this.loadCompany();
  },
};
</script>
<style scoped>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
  pointer-events: none;
}
</style>
<style>
/* Optional: Add some basic styling for your button */
.my-custom-button {
  position: absolute;
  float: right;
  z-index: 30;
  color: #000;
  margin-left: 15px;
  padding: 10px;
  top: inherit;
  bottom: 15px;
  right: 10px;
  border: 2px #fff solid;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 800;
  background-color: "#007bff";
  letter-spacing: 1.1px;
}

.my-custom-button:hover {
  background-color: #0056b3;
}
</style>
